import type { ReactNode } from 'react';
import {
  EntityCard,
  type EntityCardIconProps,
} from '../../../../components/EntityCard';

type AddTitleOptionCardProps = Pick<EntityCardIconProps, 'icon'> & {
  action: ReactNode;
  description: ReactNode;
  title: string;
};

/**
 * One registration option on the Add Title page. Same `EntityCard` shape as
 * `TitleCard` — a 96 × 64 poster-proportioned icon box, title, description,
 * right-hand action — with the option's call to action in place of the usual
 * View button.
 */
export const AddTitleOptionCard = ({
  action,
  description,
  icon,
  title,
}: AddTitleOptionCardProps) => (
  // Stacks below `sm`. `TitleCard` keeps its row intact at every width by
  // truncating, which this card cannot do: the description is prose and carries
  // the support address, so it has to wrap and the action has to move below it.
  <EntityCard className="flex-col items-start gap-4 sm:flex-row sm:items-center">
    <EntityCard.Content className="min-w-0">
      <EntityCard.Icon classes={{ wrapper: 'h-24 w-16' }} icon={icon} />

      <EntityCard.Info className="min-w-0">
        <EntityCard.Title>{title}</EntityCard.Title>

        {/* No badge row follows the description here, so drop the bottom margin
            `EntityCard.Subtitle` carries for the title and task cards. */}
        <EntityCard.Subtitle className="mb-0">
          {description}
        </EntityCard.Subtitle>
      </EntityCard.Info>
    </EntityCard.Content>

    <EntityCard.Actions>{action}</EntityCard.Actions>
  </EntityCard>
);
